export const educationData = [
    {
        id: 1,
        institution: 'Polytech Nice Sophia',
        course: 'School of engineering - Electronics, Telecommunications, Networks',
        startYear: '2017',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'IAE School of Management - Nice',
        course: 'Master of Business Administration - MAE-DE',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Civil electrical engineering, University of Louvain-la-Neuve',
        course: 'International program Semester',
        startYear: '2019',
        endYear: '2020'
    },
]